<ng-template elderToolbarColumn="right.actions">
  <button
    mat-icon-button
    [elderOverlayOrigin]="settingsPanel"
    [elderOverlayTrigger]="settingsPanel"
  >
    <mat-icon>tune</mat-icon>
  </button>

  <!-- Overlay Panel -->
  <elder-overlay #settingsPanel="elderOverlay">
    <elder-card-panel>
      <div class="layout-row place-start-center">
        <mat-slide-toggle
          [checked]="deepSearch$.getValue()"
          (change)="deepSearch$.next($event.checked)"
        >
          {{ 'Deep Search' | translate }}
        </mat-slide-toggle>
      </div>
    </elder-card-panel>
  </elder-overlay>
</ng-template>

<elder-basic-pane-layout class="full">
  <!-- assigned packages -->
  <elder-pane flat class="flex">
    @if (nodeAssignment$ | async; as assignment) {
      <div class="layout-row place-end-center gap-md p-sm">
        <mat-form-field elderFormFieldLabel style="width: 120px">
          <mat-label>{{ 'context.totalWeight' | translate }}</mat-label>
          <input
            matInput
            name="totalWeight"
            required
            [ngModel]="(assignment.weight | elderQuantity) || 0"
            readonly
          />
        </mat-form-field>
        <mat-form-field elderFormFieldLabel style="width: 120px">
          <mat-label>{{ 'context.contentWeight' | translate }}</mat-label>
          <input
            matInput
            name="totalContentWeight"
            required
            [ngModel]="(assignment.contentWeight | elderQuantity) || 0"
            readonly
          />
        </mat-form-field>
        <mat-form-field elderFormFieldLabel style="width: 120px">
          <mat-label>{{ 'storageGroups.title' | translate }}</mat-label>
          <input
            matInput
            name="totalStorageGroupsCount"
            required
            [ngModel]="assignment.storageGroupCount"
            readonly
          />
        </mat-form-field>
        <mat-form-field elderFormFieldLabel style="width: 120px">
          <mat-label>{{ 'packages.title' | translate }}</mat-label>
          <input
            matInput
            name="totalPackageCount"
            required
            [ngModel]="assignment.packageCount"
            readonly
          />
        </mat-form-field>
      </div>
    }

    <app-package-browser class="flex" [embedded]="true" [locationFilter]="locationFilter$ | async">
    </app-package-browser>
  </elder-pane>
</elder-basic-pane-layout>
